import { SourceApps, Basket } from '@maverick/entity';
import { CheckoutService } from '../services/olo/Checkout.service';

export class CheckoutManager {
    private readonly checkoutService: CheckoutService;

    constructor(sourceApp: SourceApps) {
        this.checkoutService = new CheckoutService(sourceApp);
    }

    async getBasket(basketId: string): Promise<Partial<{ retrieveBasket: Basket; error: string }>> {
        const response = await this.checkoutService.getBasket({ basketId });
        if (response.error) {
            return { error: response.errorMessage };
        }
        const basket = Basket.Make(response.body);
        return { retrieveBasket: basket };
    }
}
